module.exports = __webpack_public_path__ + "static/media/chair-bottom-cover.24b839dd.svg";